import { applySnapshot, cast, types } from 'mobx-state-tree';

import { isMobileAppWebView } from '../utils/utilsFunctions';
import { goBackToMobileApp } from '../utils/mobileApp';
import { GoBackToMobileAppProps, NextStepProps } from '../utils/mobileApp/mobileApp.types';
import { ErrorType, recordError } from './apiWrappers/api/exceptions';

const UserProgressStoreModel = types
  .model('UserProgressStoreModel', {
    currentStep: types.optional(types.number, 0),
    steps: types.array(types.string),
    backUrl: types.maybeNull(types.string),
  })
  .actions((self) => ({
    addStep(stepId: string) {
      if (self.steps.length > 0) {
        const lastStep = self.steps[self.steps.length - 1];
        if (stepId === lastStep) {
          return;
        }
      }
      self.steps.push(stepId);
    },
    setBackUrl(backUrl: string) {
      if (!!backUrl) {
        applySnapshot(self, { ...self, backUrl });
      }
    },
    removeLastStep() {
      return self.steps.pop();
    },
    back(goToStep: (stepId: string) => void) {
      self.steps.pop();

      const backStepId = self.steps[self.steps.length - 1];

      goToStep(backStepId);
    },
    goToParticularStep(stepId: string, goToStep: (stepId: string) => void) {
      const stepIndex = self.steps.findIndex((item) => item === stepId);

      if (stepIndex === -1) {
        recordError(ErrorType.HANDLED, 'Step not found', { stepId, steps: [...self.steps] });
        return;
      }

      const newSteps = self.steps.slice(0, stepIndex);
      self.steps = cast(newSteps);
      goToStep(stepId);
    },
    goToApp(goToAppProp: GoBackToMobileAppProps, nextStepProps?: NextStepProps) {
      if (isMobileAppWebView) {
        goBackToMobileApp(goToAppProp);
        return;
      }

      if (!!self.backUrl) {
        window.location.href = self.backUrl;
        return;
      }

      if (nextStepProps && nextStepProps.currentStep < nextStepProps.totalSteps) {
        nextStepProps.nextStep();
      }
    },
    setCurrentStep(step: number) {
      self.currentStep = step;
    },
  }))
  .views((self) => ({
    get isFirstStep(): boolean {
      return self.currentStep === 0;
    },
  }));

export { UserProgressStoreModel };
